import { render } from "./RegisterTypeOfDocuments.vue?vue&type=template&id=dfdec6da"
import script from "./RegisterTypeOfDocuments.vue?vue&type=script&lang=js"
export * from "./RegisterTypeOfDocuments.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__